export const NOTIFICATION_EVENT_DEFINITIONS = [
  { key: 'mentioned', domain: 'tasks', label: 'Mencionou-me', description: 'Quando alguém menciona @suas iniciais em atualização ou resposta.' },
  { key: 'assigned', domain: 'tasks', label: 'Atribuiu-me', description: 'Quando você é adicionado na equipe de tarefas ou álbuns.' },
  { key: 'automations', domain: 'system', label: 'Automações que notificam', description: 'Eventos automáticos configurados pelo sistema.' },
  { key: 'taskStatusChanged', domain: 'tasks', label: 'Mudança de status (tarefas)', description: 'Quando uma tarefa muda de etapa.' },
  { key: 'taskDueDateChanged', domain: 'tasks', label: 'Mudança de prazo (tarefas)', description: 'Quando a data de entrega é alterada.' },
  { key: 'overdueAlert', domain: 'tasks', label: 'Alerta de atraso', description: 'Quando item entra ou permanece em atraso.' },
  { key: 'commentAdded', domain: 'tasks', label: 'Comentário/atualização nova', description: 'Quando há atualização em tarefa monitorada.' },
  { key: 'taskCompleted', domain: 'tasks', label: 'Tarefa finalizada', description: 'Quando tarefa é movida para finalizado/concluído.' },
  { key: 'albumStatusChanged', domain: 'albums', label: 'Mudança de status (álbuns)', description: 'Quando um álbum muda de etapa no fluxo.' },
  { key: 'albumPrintSent', domain: 'albums', label: 'Enviado para impressão', description: 'Quando álbum é enviado para gráfica/laboratório.' },
  { key: 'albumPrintFinished', domain: 'albums', label: 'Impressão finalizada', description: 'Quando a gráfica finaliza e a chegada do álbum é confirmada.' },
  { key: 'albumEtaChanged', domain: 'albums', label: 'Previsão de chegada alterada', description: 'Quando data de chegada prevista é modificada.' },
  { key: 'albumMaterialDelivered', domain: 'albums', label: 'Material entregue', description: 'Quando álbum é marcado como entregue.' },
  { key: 'albumReviewChangesRequested', domain: 'albums', label: 'Alterações solicitadas', description: 'Quando o cliente solicita correções na revisão do álbum.' },
  { key: 'albumReviewApproved', domain: 'albums', label: 'Projeto aprovado pelo cliente', description: 'Quando o cliente aprova formalmente o projeto do álbum.' },
];

export const DEFAULT_EVENT_FLAGS = NOTIFICATION_EVENT_DEFINITIONS.reduce((acc, def) => {
  acc[def.key] = true;
  return acc;
}, {});

const EDITOR_DEFAULT_EVENTS = {
  ...DEFAULT_EVENT_FLAGS,
  taskStatusChanged: true,
  taskDueDateChanged: true,
  overdueAlert: true,
  commentAdded: true,
  taskCompleted: false,
  albumStatusChanged: false,
  albumPrintSent: true,
  albumEtaChanged: true,
  albumMaterialDelivered: true,
};

const ADMIN_DEFAULT_EVENTS = {
  ...DEFAULT_EVENT_FLAGS,
  mentioned: true,
  assigned: true,
  automations: true,
  taskStatusChanged: true,
  taskDueDateChanged: true,
  overdueAlert: true,
  commentAdded: true,
  taskCompleted: true,
  albumStatusChanged: true,
  albumPrintSent: true,
  albumEtaChanged: true,
  albumMaterialDelivered: true,
};

export const DEFAULT_NOTIFICATION_SETTINGS = {
  globalMuteAll: false,
  antiNoiseWindowMinutes: 15,
  users: {},
};

export const createDefaultUserNotificationPrefs = (role = 'editor') => {
  const isAdmin = role === 'admin';
  return {
    mode: 'custom', // all | mute | custom
    scope: { tasks: true, albums: true },
    channels: { inApp: true, toast: true, browser: true },
    frequency: 'realtime', // realtime | hourly | daily
    quietHours: { enabled: false, start: '20:00', end: '07:00' },
    events: isAdmin ? { ...ADMIN_DEFAULT_EVENTS } : { ...EDITOR_DEFAULT_EVENTS },
  };
};

export const normalizeUserNotificationPrefs = (rawPrefs, role = 'editor') => {
  const defaults = createDefaultUserNotificationPrefs(role);
  if (!rawPrefs || typeof rawPrefs !== 'object') return defaults;
  return {
    mode: rawPrefs.mode || defaults.mode,
    scope: {
      tasks: rawPrefs.scope?.tasks ?? defaults.scope.tasks,
      albums: rawPrefs.scope?.albums ?? defaults.scope.albums,
    },
    channels: {
      inApp: rawPrefs.channels?.inApp ?? defaults.channels.inApp,
      toast: rawPrefs.channels?.toast ?? defaults.channels.toast,
      browser: rawPrefs.channels?.browser ?? defaults.channels.browser,
    },
    frequency: rawPrefs.frequency || defaults.frequency,
    quietHours: {
      enabled: rawPrefs.quietHours?.enabled ?? defaults.quietHours.enabled,
      start: rawPrefs.quietHours?.start || defaults.quietHours.start,
      end: rawPrefs.quietHours?.end || defaults.quietHours.end,
    },
    events: {
      ...defaults.events,
      ...(rawPrefs.events || {}),
    },
  };
};

const parseHourAndMinute = (value) => {
  if (!value || typeof value !== 'string' || !value.includes(':')) return null;
  const [h, m] = value.split(':').map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  return { h, m };
};

export const isNowInQuietHours = (dateObj, quietHours) => {
  if (!quietHours?.enabled) return false;
  const start = parseHourAndMinute(quietHours.start);
  const end = parseHourAndMinute(quietHours.end);
  if (!start || !end) return false;
  const nowMinutes = dateObj.getHours() * 60 + dateObj.getMinutes();
  const startMinutes = start.h * 60 + start.m;
  const endMinutes = end.h * 60 + end.m;
  if (startMinutes === endMinutes) return false;
  if (startMinutes < endMinutes) {
    return nowMinutes >= startMinutes && nowMinutes < endMinutes;
  }
  return nowMinutes >= startMinutes || nowMinutes < endMinutes;
};
